const DAY_CODES = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
const WEEK_INDEX = { First: 1, Second: 2, Third: 3, Fourth: 4 };

function parseDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
}

function occurrenceMatches(form = {}, date) {
  const recurrence = form.recurrence || {};
  const expectedDay = recurrence.byDay?.[0] || form.dayOfWeek?.slice(0, 2).toUpperCase();
  if (expectedDay && DAY_CODES[date.getDay()] !== expectedDay) return false;
  const frequency = String(recurrence.frequency || form.frequency || 'WEEKLY').toUpperCase();
  if (frequency !== 'MONTHLY') return true;
  const week = recurrence.weekOfMonth || form.weekOfMonth || 'First';
  if (week === 'Last') {
    const nextWeek = new Date(date);
    nextWeek.setDate(nextWeek.getDate() + 7);
    return nextWeek.getMonth() !== date.getMonth();
  }
  return Math.ceil(date.getDate() / 7) === (WEEK_INDEX[week] || 1);
}

export function getFinalSeriesOccurrenceId(form = {}) {
  const endId = form.recurrence?.endDate || form.recurrenceEndDate || '';
  const end = parseDate(endId);
  if (!end) return '';
  for (let offset = 0; offset <= 31; offset += 1) {
    const candidate = new Date(end);
    candidate.setDate(candidate.getDate() - offset);
    if (!occurrenceMatches(form, candidate)) continue;
    return `${candidate.getFullYear()}-${String(candidate.getMonth() + 1).padStart(2, '0')}-${String(candidate.getDate()).padStart(2, '0')}`;
  }
  return '';
}

function occurrenceEnd(form = {}, dateId = '') {
  const time = form.time || form.recurrence?.time || '00:00';
  const start = new Date(`${dateId}T${time}`);
  if (Number.isNaN(start.getTime())) return null;
  return new Date(start.getTime() + Math.max(1, Number(form.durationMinutes || 60)) * 60000);
}

export function getEventPayoutTiming(form = {}, occurrenceId = '') {
  if (form.attendanceMode !== 'ticketed') return null;
  const delayHours = Math.max(0, Number(form.transferDelayHours ?? 24));
  const isRecurring = form.type === 'recurring' || Boolean(form.recurrence?.byDay?.length);
  let coverageLabel = 'this event';
  let coveredEnd = null;

  if (!isRecurring) {
    coveredEnd = occurrenceEnd(form, form.date || '');
  } else if (form.ticketPaymentBasis === 'whole_series') {
    coverageLabel = 'the whole series';
    coveredEnd = occurrenceEnd(form, getFinalSeriesOccurrenceId(form));
  } else {
    coverageLabel = 'each occurrence';
    coveredEnd = occurrenceEnd(form, occurrenceId || form.occurrenceId || '');
  }

  const eligibleAt = coveredEnd ? new Date(coveredEnd.getTime() + delayHours * 3600000) : null;
  return { coverageLabel, coveredEnd, eligibleAt, delayHours };
}

export function formatEventPayoutTiming(form = {}, occurrenceId = '') {
  const timing = getEventPayoutTiming(form, occurrenceId);
  if (!timing) return '';
  const suffix = 'Bank arrival then follows the club’s Stripe payout schedule.';
  if (!timing.eligibleAt) {
    return form.ticketPaymentBasis === 'per_occurrence'
      ? `Funds become eligible for transfer ${timing.delayHours} hours after each occurrence ends. ${suffix}`
      : `Funds become eligible for transfer ${timing.delayHours} hours after ${timing.coverageLabel} ends. ${suffix}`;
  }
  const when = timing.eligibleAt.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
  return `Funds become eligible for transfer on ${when}, ${timing.delayHours} hours after ${timing.coverageLabel} ends. ${suffix}`;
}
